import { render, staticRenderFns } from "./DetalharUsoDisciplinaDialog.vue?vue&type=template&id=cf2d0a8e&scoped=true"
import script from "./DetalharUsoDisciplinaDialog.vue?vue&type=script&lang=js"
export * from "./DetalharUsoDisciplinaDialog.vue?vue&type=script&lang=js"
import style0 from "./DetalharUsoDisciplinaDialog.vue?vue&type=style&index=0&id=cf2d0a8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf2d0a8e",
  null
  
)

export default component.exports